module.exports = __webpack_public_path__ + "51b72ddc3445bf1df1b54d5e6b53909e.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/users-shared-accounts/users-shared-accounts.html
// module id = 2161
// module chunks = 0